import Api from '../api/Api';
import resolve from  '../util/Configuracao';

class DividaServDesligadoApi extends Api {
  async consultarEventos () {
    try {
      const eventosUrl = resolve('urlConsultarEventosDividaServDesligado');
      const response = await this.fetch(eventosUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarTipos () {
    try {
      const tiposUrl = resolve('urlConsultarTiposDividaServDesligado');
      const response = await this.fetch(tiposUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarServidoresDesligados () {
    try {
      const urlConsultarServidoresDesligados = resolve('urlConsultarServidoresDesligados');
      const response = await this.fetch(urlConsultarServidoresDesligados);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarDividas (numMatricula, codEvento, codTipo, dataInicial, dataFinal, apenasSemBaixa) {
    let dividas = [];
    let brancoAcoes = '';
    let tipoBotaoCancelamento = '';
    try {
      const dividaUrl = resolve('urlConsultarDividasServDesligado') +
      numMatricula + '/' +
      codEvento + '/' +
      codTipo + '/' +
      dataInicial + '/' +
      dataFinal + '/' +
      apenasSemBaixa;
      const { data } = await this.fetch(dividaUrl, 'post');
      data.map(res => {
        const { numDivida, seqBeneficiario, seqDependente, numMatricula, nomeBeneficiario, codEvento, desEvento, codTipo, desTipo, dtaCadastro,	valDivida, txtObservacao, dtaCancelamento, txtMotivoCancelamento, codUsuarioCancelamento, valTotalBaixado, baixas, anoProcesso, numProcesso, txtProcessoSei } = res;
        if (codUsuarioCancelamento.trim() !== '') {
          tipoBotaoCancelamento = 'DESFAZER';
        } else {
          tipoBotaoCancelamento = 'CANCELAR';
        }
        dividas.push(Object.values({ numDivida, seqBeneficiario, seqDependente, numMatricula, nomeBeneficiario, codEvento, desEvento, codTipo, desTipo, dtaCadastro,	valDivida, txtObservacao, dtaCancelamento, txtMotivoCancelamento, codUsuarioCancelamento, valTotalBaixado, baixas, tipoBotaoCancelamento, anoProcesso, numProcesso, txtProcessoSei, brancoAcoes }));
      });
      return dividas || [];
    } catch (error) {
      console.error(error);
    }
  }

  async incluirDivida (divida) {
    try {
      const urlIncluirDivida = resolve('urlIncluirDivida');
      const response = await this.fetch(urlIncluirDivida, 'put', divida);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarDivida (divida) {
    try {
      const urlAlterarDivida = resolve('urlAlterarDivida');
      const response = await this.fetch(urlAlterarDivida, 'put', divida);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirDivida (numDivida) {
    try {
      const urlExcluirDivida = resolve('urlExcluirDivida') + numDivida;
      const response = await this.fetch(urlExcluirDivida, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async cancelarDivida (numDivida, motivoCancelamento) {
    try {
      const urlCancelarDivida = resolve('urlCancelarDivida') + numDivida + '/' + motivoCancelamento;
      const response = await this.fetch(urlCancelarDivida, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async desfazerCancelamentoDivida (numDivida) {
    try {
      const urlDesfazerCancelamentoDivida = resolve('urlDesfazerCancelamentoDivida') + numDivida;
      const response = await this.fetch(urlDesfazerCancelamentoDivida, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async validarDivida (divida) {
    try {
      const urlValidarDivida = resolve('urlValidarDivida');
      const response = await this.fetch(urlValidarDivida, 'put', divida);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async baixarAutomaticamente (divida) {
    try {
      const urlBaixarAutomaticamente = resolve('urlBaixarAutomaticamente');
      const response = await this.fetch(urlBaixarAutomaticamente, 'put', divida);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async compensarCredito (divida) {
    try {
      const urlCompensarCredito = resolve('urlCompensarCredito');
      const response = await this.fetch(urlCompensarCredito, 'put', divida);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
}
export default DividaServDesligadoApi;
